"use strict";
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.operation = exports.Operation = void 0;

var events_1 = require("events");

var status_1 = require("../status");

var googleError_1 = require("../googleError");

var operationProtos = require("../../protos/operations");

var Operation =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(Operation, _events_1$EventEmitte);

  /**
   * Wrapper for a google.longrunnung.Operation.
   *
   * @constructor
   *
   * @param {google.longrunning.Operation} grpcOp - The operation to be wrapped.
   * @param {LongRunningDescriptor} longrunningDescriptor - This defines the
   * operations service client and unpacking mechanisms for the operation.
   * @param {BackoffSettings} backoffSettings - The backoff settings used in
   * in polling the operation.
   * @param {CallOptions} callOptions - CallOptions used in making get operation
   * requests.
   */
  function Operation(grpcOp, longrunningDescriptor, backoffSettings, callOptions) {
    var _this;

    _classCallCheck(this, Operation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Operation).call(this));
    _this.completeListeners = 0;
    _this.hasActiveListeners = false;
    _this.latestResponse = grpcOp;
    _this.name = _this.latestResponse.name;
    _this.done = _this.latestResponse.done;
    _this.error = _this.latestResponse.error;
    _this.longrunningDescriptor = longrunningDescriptor;
    _this.result = null;
    _this.metadata = null;
    _this.backoffSettings = backoffSettings;

    _this._unpackResponse(grpcOp);

    _this._listenForEvents();

    _this._callOptions = callOptions;
    return _this;
  }
  /**
   * Begin listening for events on the operation. This method keeps track of how
   * many "complete" listeners are registered and removed, making sure polling
   * is handled automatically.
   *
   * As long as there is one active "complete" listener, the connection is open.
   * When there are no more listeners, the polling stops.
   *
   * @private
   */


  _createClass(Operation, [{
    key: "_listenForEvents",
    value: function _listenForEvents() {
      var _this2 = this;

      this.on('newListener', function (event) {
        if (event === 'complete') {
          _this2.completeListeners++;

          if (!_this2.hasActiveListeners) {
            _this2.hasActiveListeners = true;

            _this2.startPolling_();
          }
        }
      });
      this.on('removeListener', function (event) {
        if (event === 'complete' && --_this2.completeListeners === 0) {
          _this2.hasActiveListeners = false;
        }
      });
    }
    /**
     * Cancels current polling api call and cancels the operation.
     *
     * @return {Promise} the promise of the OperationsClient#cancelOperation api
     * request.
     */

  }, {
    key: "cancel",
    value: function cancel() {
      if (this.currentCallPromise_) {
        this.currentCallPromise_.cancel();
      }

      var operationsClient = this.longrunningDescriptor.operationsClient;
      var cancelRequest = new operationProtos.google.longrunning.CancelOperationRequest();
      cancelRequest.name = this.latestResponse.name;
      return operationsClient.cancelOperation(cancelRequest);
    }
  }, {
    key: "getOperation",
    value: function getOperation(callback) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var self = this;
      var operationsClient = this.longrunningDescriptor.operationsClient;

      function promisifyResponse() {
        if (!callback) {
          return new Promise(function (resolve, reject) {
            if (self.latestResponse.error) {
              var error = new googleError_1.GoogleError(self.latestResponse.error.message);
              error.code = self.latestResponse.error.code;
              reject(error);
            } else {
              resolve([self.result, self.metadata, self.latestResponse]);
            }
          });
        }

        return;
      }

      if (this.latestResponse.done) {
        this._unpackResponse(this.latestResponse, callback);

        return promisifyResponse();
      }

      var request = new operationProtos.google.longrunning.GetOperationRequest();
      request.name = this.latestResponse.name;
      this.currentCallPromise_ = operationsClient.getOperationInternal(request, this._callOptions);
      var noCallbackPromise = this.currentCallPromise_.then(function (responses) {
        self.latestResponse = responses[0];

        self._unpackResponse(responses[0], callback);

        return promisifyResponse();
      });

      if (!callback) {
        return noCallbackPromise;
      }
    }
  }, {
    key: "_unpackResponse",
    value: function _unpackResponse(op, callback) {
      var responseDecoder = this.longrunningDescriptor.responseDecoder;
      var metadataDecoder = this.longrunningDescriptor.metadataDecoder;
      var response;
      var metadata;

      if (op.done) {
        if (op.result === 'error') {
          var error = new googleError_1.GoogleError(op.error.message);
          error.code = op.error.code;
          this.error = error;

          if (callback) {
            callback(error);
          }

          return;
        }

        if (responseDecoder && op.response) {
          this.response = op.response;
          response = responseDecoder(op.response.value);
          this.result = response;
          this.done = true;
        }
      }

      if (metadataDecoder && op.metadata) {
        metadata = metadataDecoder(op.metadata.value);
        this.metadata = metadata;
      }

      if (callback) {
        callback(null, response, metadata, op);
      }
    }
    /**
     * Poll `getOperation` to check the operation's status. This runs a loop to
     * ping using the backoff strategy specified at initialization.
     *
     * Note: This method is automatically called once a "complete" event handler
     * is registered on the operation.
     *
     * @private
     */

  }, {
    key: "startPolling_",
    value: function startPolling_() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var self = this;
      var now = new Date();
      var delayMult = this.backoffSettings.retryDelayMultiplier;
      var maxDelay = this.backoffSettings.maxRetryDelayMillis;
      var delay = this.backoffSettings.initialRetryDelayMillis;
      var deadline = Infinity;

      if (this.backoffSettings.totalTimeoutMillis) {
        deadline = now.getTime() + this.backoffSettings.totalTimeoutMillis;
      }

      var previousMetadataBytes;

      if (this.latestResponse.metadata) {
        previousMetadataBytes = this.latestResponse.metadata.value;
      } // eslint-disable-next-line @typescript-eslint/no-explicit-any


      function emit(event) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        self.emit.apply(self, [event].concat(args));
      } // Helper function to replace nodejs buffer's equals()


      function arrayEquals(a, b) {
        if (a.byteLength !== b.byteLength) {
          return false;
        }

        for (var i = 0; i < a.byteLength; ++i) {
          if (a[i] !== b[i]) return false;
        }

        return true;
      }

      function retry() {
        if (!self.hasActiveListeners) {
          return;
        }

        if (now.getTime() >= deadline) {
          var error = new googleError_1.GoogleError('Total timeout exceeded before any response was received');
          error.code = status_1.Status.DEADLINE_EXCEEDED;
          setImmediate(emit, 'error', error);
          return;
        }

        self.getOperation(function (err, result, metadata, rawResponse) {
          if (err) {
            setImmediate(emit, 'error', err);
            return;
          }

          if (!result) {
            if (rawResponse.metadata && (!previousMetadataBytes || rawResponse && !arrayEquals(rawResponse.metadata.value, previousMetadataBytes))) {
              setImmediate(emit, 'progress', metadata, rawResponse);
              previousMetadataBytes = rawResponse.metadata.value;
            } // special case: some APIs fail to set either result or error
            // but set done = true (e.g. speech with silent file).
            // Some APIs just use this for the normal completion
            // (e.g. nodejs-contact-center-insights), so let's just return
            // an empty response in this case.


            if (rawResponse.done) {
              setImmediate(emit, 'complete', {}, metadata, rawResponse);
              return;
            }

            setTimeout(function () {
              now = new Date();
              delay = Math.min(delay * delayMult, maxDelay);
              retry();
            }, delay);
            return;
          }

          setImmediate(emit, 'complete', result, metadata, rawResponse);
        });
      }

      retry();
    }
    /**
     * Wraps the `complete` and `error` events in a Promise.
     *
     * @return {promise} - Promise that resolves on operation completion and rejects
     * on operation error.
     */

  }, {
    key: "promise",
    value: function promise() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.on('error', reject).on('complete', function (result, metadata, rawResponse) {
          resolve([result, metadata, rawResponse]);
        });
      });
    }
  }]);

  return Operation;
}(events_1.EventEmitter);

exports.Operation = Operation;
/**
 * Method used to create Operation objects.
 *
 * @constructor
 *
 * @param {google.longrunning.Operation} op - The operation to be wrapped.
 * @param {LongRunningDescriptor} longrunningDescriptor - This defines the
 * operations service client and unpacking mechanisms for the operation.
 * @param {BackoffSettings} backoffSettings - The backoff settings used in
 * in polling the operation.
 * @param {CallOptions=} callOptions - CallOptions used in making get operation
 * requests.
 */

function operation(op, longrunningDescriptor, backoffSettings, callOptions) {
  return new Operation(op, longrunningDescriptor, backoffSettings, callOptions);
}

exports.operation = operation;